// extracted by mini-css-extract-plugin
export default {"title":"_2toBNQOM","subtitle":"_2h1JEk-Z"};